import type { DomApplier } from '../cssFeatures.types'

export const pinnedLayoutDomApplier: DomApplier<'pinnedLayout'> = (__, ___, ____, { pinnedStyle }) =>
	pinnedStyle && 'type' in pinnedStyle && pinnedStyle?.type === 'SelectorObj' ? pinnedStyle.selectorObj : null
